module.exports = __webpack_public_path__ + "static/media/25KM.5188d564.webp";